<template>
  <div class="tooltip">
    <svgicon src="icon/tooltip.svg" :height="14" :width="14"></svgicon>
    <div class="box" v-html="text"></div>
  </div>
</template>

<script>
  export default {
    name: "Tooltip",

    props: {
      text: String
    },

    data() {
      return {
        visible: false
      };
    },

    methods: {
      toggle() {
        this.visible = !this.visible;
      }
    }
  };
</script>

<style lang="scss" scoped>

  .tooltip {
    position: relative;
    cursor: pointer;

    &:hover {
      .box {
        display: block;
        white-space: pre-wrap;
      }
    }
  }

  .box {
    display: none;
    position: absolute;
    bottom: 30px;
    transform: translateX(-42%);
    background-color: white;
    color: #808080;
    border-radius: 16px;
    padding: 16px;
    text-transform: none;
    font-weight: normal;
    width: 200px;
    line-height: 1.2;
    text-align: center;
    font-size: 13px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.16);
    z-index: 1;

    &::after {
      content: "";
      position: absolute;
      bottom: -10px;
      left: 40%;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid white;
    }
  }

</style>